import { styled } from '@storybook/theming';
import { Text } from '../Text';

export const PostExcerpt = styled(Text.withComponent('section'))`
  margin-bottom: 20px;
`;
